import styled from 'styled-components';

export const StyledProductListItem = styled.div`
  display: grid;
  grid-template-columns: 5rem 1fr;
  column-gap: 2rem;
  align-items: center;
`;
